export default import.meta.ROLLDOWN_FILE_URL_uFId83jSdgV9I4oCl8vk1A